import { render, staticRenderFns } from "./TestCheckAnswersTabContent.vue?vue&type=template&id=352401b8&scoped=true&"
import script from "./TestCheckAnswersTabContent.vue?vue&type=script&lang=js&"
export * from "./TestCheckAnswersTabContent.vue?vue&type=script&lang=js&"
import style0 from "./TestCheckAnswersTabContent.vue?vue&type=style&index=0&id=352401b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352401b8",
  null
  
)

export default component.exports